import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.svg";
import { filterBySearchText } from "../features/filter/filterSlice";


export default function Navigation() {
	//Variables
	const dispatch = useDispatch();
	const navigate = useNavigate();

	//Functions
	const handleFilterBySearchText = (text) => {
		dispatch(filterBySearchText(text));
		navigate("/tasks");
	}


	//JSX
	return (
		<nav className="container relative py-3">
			<div className="flex items-center justify-between">
				<Link to="/">
					<img src={logo} alt="logo" />
				</Link>
				<div className="flex-1 max-w-xs search-field group">
					<i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
					<input type="text" placeholder="Search Task" className="search-input" id="lws-searchTask" style={{ color: "black" }} onChange={(e) => handleFilterBySearchText(e.target.value)} />
				</div>
			</div>
		</nav>
	);
}
